import { getJobHistory } from '@/api/jobs'
import { useQuery } from '@tanstack/vue-query'
import { MaybeRef } from '@vueuse/core'
import { computed, unref } from 'vue'
import moment from 'moment'
import { AxiosError } from 'axios'

export function useGetJobHistory(jobNumber: MaybeRef<number>) {
  const computedJobNumber = computed(() => unref(jobNumber))
  const queryKey = computed(() => ['history', 'byJobNumber', computedJobNumber.value])
  return useQuery({
    queryKey,
    queryFn: async ({ signal }) => await getJobHistory(computedJobNumber.value, signal),
    staleTime: moment.duration(10, 'minutes').asMilliseconds(),
    retry: (failureCount, error: AxiosError) =>
      failureCount < 3 && error.status !== undefined && error.status >= 500,
  })
}
